// @flow

import {fromJS} from 'immutable';

import {
  defaultFetchDataFormat,
  mergeNormalizedFetchData,
} from 'app/utils/redux';
import {
  type PolicyActionType,
  RECEIVE_POLICIES_DASHBOARD_LIST,
  RECEIVE_POLICY_DETAIL,
  RECEIVE_POLICY_LIST,
  RECEIVE_POLICY_VERSION_DETAIL,
} from './actions';
import type {PolicyVersionType} from './types';
import {setNormalizedList} from 'app/utils/redux_v2';

const initialState = {
  policies: defaultFetchDataFormat(),
  versions: defaultFetchDataFormat(),
  procedures: defaultFetchDataFormat(),
  processes: defaultFetchDataFormat(),

  // v2 reducers
  byId: {},
  queries: {},
  dashboard: {
    currentFilters: {},
    activeRelations: {},
  },
};

const buildSingleItemEndpointResponse = (item: any) => ({
  results: [item],
  previous: null,
  next: null,
  num_pages: 1,
  count: 1,
});

const updateVersion = (state, version: PolicyVersionType) => {
  const path = ['versions', version.version_object_id.toString()];

  return state.setIn(
    path,
    mergeNormalizedFetchData(
      buildSingleItemEndpointResponse(version),
      state.getIn(path)
    )
  );
};

function policies(
  state: any = fromJS(initialState),
  action: PolicyActionType
): any {
  switch (action.type) {
    case RECEIVE_POLICY_DETAIL: {
      const immutablePolicy = fromJS(action.policy);
      return state
        .setIn(
          ['policies', 'byId', action.policy.id.toString()],
          immutablePolicy
        )
        .setIn(['byId', action.policy.id.toString()], immutablePolicy);
    }
    case RECEIVE_POLICY_LIST:
      return state.set(
        'policies',
        mergeNormalizedFetchData(action.policies, state.get('policies'))
      );

    case RECEIVE_POLICY_VERSION_DETAIL:
      return updateVersion(state, action.version);

    case RECEIVE_POLICIES_DASHBOARD_LIST:
      return setNormalizedList(action.query, action.response, state).set(
        'isFetching',
        false
      );

    default:
      return state;
  }
}

export default policies;
